export const kmMessages = {
  error: {
    login: {
      invaliduserpass:
        "Wprowadzono nieprawidłowy login lub hasło. Proszę sprawdzić czy funkcja CAPS LOCK jest wyłączona. Liczba pozostałych prób logowania: {count}",
      badloginpass:
        "Wprowadzono nieprawidłowy login lub hasło. Proszę sprawdzić czy funkcja CAPS LOCK jest wyłączona.",
      triescountexc:
        "Dokonano {count} błędnych prób logowania do systemu. Ponowna możliwość logowania do systemu nastąpi po upływie {timeout} minut od ostatniej próby logowania.",
      unexgetprofile:
        "Wystąpił nieoczekiwany problem z pobraniem profilu. Skontaktuj się z administratorem aplikacji.",
    },
    password_reset: {
      username: "Aby odzyskać hasło proszę podać login użytkownika",
      usernotex:
        "W systemie nie zarejestrowano użytkownika o podanym loginie. Jeżeli posiadasz uprawnienia do systemu, skontaktuj się z Administratorem Systemu.",
      linkexpired: "Link aktywacyjny wygasł lub jest nieprawidłowy.",
      usernotactive:
        "Konto użytkownika o podanym loginie jest nieaktywne. W przypadku pytań bądź wątpliwości, skontaktuj się z Administratorem Systemu.",
      unexpasschange:
        "Wystąpił nieoczekiwany problem ze zmianą hasła. Skontaktuj się z administratorem aplikacji.",
      passnotmatch: "Podane hasła różnią się od siebie.",
      passwrong: "Błędne hasło",
      passcurrwrong: "Błędne obecne hasło",
      passstrength:
        "Podane hasło nie spełnia kryteriów. Hasło powinno składać się z co najmniej 8 znaków, w tym co najmniej 2 cyfry, 2 małe litery, 2 wielkie litery, 2 znaki specjalne (!\"#$%&'()*+<=>?@).",
      passuniqinpast:
        "Nowe hasło musi się różnić od {count} ostatnich haseł systemu",
    },
    form_validation: {
      field_required: "Pole wymagane",
      field_maxlengthnum:
        "Wprowadzona wartość jest za długa. Maksymalna ilość znaków to: {maxlen}",
      field_wrongemail: "Niepoprawny adres email",
      field_wronginputformat: "Niepoprawny format wprowadzonych danych",
      field_datechoice:
        "Należy wskazać datę lub wybrać opcję automatycznego uzupełnienia",
      field_dateonlychoice: "Należy wskazać datę",
      field_votinganswechoice: "Należy wybrać minimum 2 warianty odpowiedzi",
      username_exists: "Uzytkownik o podanym loginie istnieje już w systemie",
      activation_inpast:
        "Data aktywności konta nie może być wcześniejsza niż data bieżąca",
      email_exists:
        "Uzytkownik o podanym adresie email istnieje już w systemie",
      activity_not_defined: "Należy zdefiniować czas aktywności konta",
    },
    users: {
      superuser_delete: "Nie można usunąć konta typu SUPERADMIN",
      voted_user_delete:
        "Nie można usunać konta użytkownika, który posiada w portalu KM złożone głosy",
      emails_user_delete:
        "Nie można usunać konta użytkownika, któremu wysyłano powiadomienia z systemu",
      user_with_function_exists:
        "W ramach instytucji istnieje już uzytkownik o tej funkcji. Instytucja może mieć tylko 1 aktywnego Członka i 1 aktywnego Zastępcę Członka Komitetu",
    },
    voting: {
      voteoption_notselected:
        "Nie wskazano wariantu odpowiedzi, głos nie może być zapisany.",
      voteoption_votingfinished:
        "Głosowanie zostało zakończone. Nie można zapisać głosu.",
      voteoption_datestarttoold:
        "Data rozpoczęcia głosowania nie może być wcześniejsza niż bieżąca",
      voteoption_dateendtoold:
        "Data zakończenia głosowania nie może być wcześniejsza niż bieżąca",
      voteoption_dateendolderthanstart:
        "Data zakończenia głosowania nie może być wcześniejsza lub równa dacie rozpoczęcia",
    },
    calendar: {
      calendarevent_datestarttoold:
        "Data rozpoczęcia wydarzenia nie może być wcześniejsza niż bieżąca",
      calendarevent_dateendtoold:
        "Data zakończenia wydarzenia nie może być wcześniejsza niż bieżąca",
      calendarevent_dateendolderthanstart:
        "Data zakończenia wydarzenia nie może być wcześniejsza lub równa dacie rozpoczęcia",
    },
    mailing: {
      missing_recipients:
        "Nie wprowadzono adresatów powiadomienia"
    },
    global: {
      apierror:
        "Wystąpił nieprzewidziany błąd. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem aplikacji.",
      apierrornoresp:
        "Wystąpił błąd połączenia z serwerem. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem aplikacji.",
      genericerror: "Wystąpił nieprzewidziany błąd.",
    },
    admin: {
      function_role_exist:
        "Inna funkcja posiada już wybraną rolę. W systemie może istnieć tylko jedna funkcja o danej roli",
    },
    document: {
      file_not_selected:
        "Nie załadowano pliku dokumentu. Aby zapisać należy załadować plik.",
      search_not_result:
        "Nie znaleziono żadnego dokumentu zawierającego wprowadzoną frazę.",
      document_upload_error: "Wystąpił problem z importem pliku '{filename}'.",
      attendance_foruser_option:
        "Nie wskazano wariantu potwierdzenie, potwierdzenie nie może być zapisane.",
    },
  },
  info: {
    password_reset: {
      mailsenttitle:
        "Link do zmiany hasła został wysłany na Państwa adres e-mail zdefiniowany w systemie.",
      mailsentbody:
        'Jeżeli w ciągu 30 minut nie otrzymają Państwo wiadomości z adresu <a href="mailto:%s">%s</a>, proszę o kontakt z Administratorem Merytorycznym Portalu KM.',
      passchangesuccess: "Hasło zostało pomyślnie zmienione.",
    },
    voting: {
      voteoption_votesuccessfulsaved: "Głos został zarejestrowany",
    },
    admin: {
      config_saved: "Konfiguracja została zapisana",
    },
    document: {
      not_selected: "Nie zaznaczono żadnych katalogów lub dokumentów",
      voting_delete:
        "Wśród zaznaczonych dokumentów są dokumenty powiązane z głosowaniami, takich dokumentów nie można usuwać",
      voting_move:
        "Wśród zaznaczonych dokumentów są dokumenty powiązane z głosowaniami, takich dokumentów nie można przenosić",
      moving_status:
        "Wszyskie wybrane do przeniesienia katalogi i dokumenty muszą mieć taki sam status",
      moving_not_selected: "Nie wybrano katalogów/dokumentów do przeniesienia",
    },
  },
};

export const kmSystemLabels = {
  programShortcut: {
    rpowp1420: "RPOWP",
    fedp2127: "FEdP",
    default: ""
  },
  programShortcutYears: {
    rpowp1420: "RPOWP 2014-2020",
    fedp2127: "FEdP 2021-2027",
    default: ""
  },
  program: {
    rpowp1420:
      "Regionalny Program Operacyjny Województwa Podlaskiego",
    fedp2127: "program Fundusze Europejskie dla Podlaskiego",
    default:
      ""
  },
  programUpperYears: {
    rpowp1420:
      "REGIONALNY PROGRAM OPERACYJNY WOJEWÓDZTWA PODLASKIEGO NA LATA 2014-2020",
    fedp2127: "PROGRAM FUNDUSZE EUROPEJSKIE DLA PODLASKIEGO 2021-2027",
    default:
      ""
  },
  programYears: {
    rpowp1420:
      "Regionalny Program Operacyjny Województwa Podlaskiego na lata 2014-2020",
    fedp2127: "program Fundusze Europejskie dla Podlaskiego 2021-2027",
    default:
      ""
  },
  programYearsGo: {
    rpowp1420:
      "Regionalnego Programu Operacyjnego Województwa Podlaskiego na lata 2014-2020",
    fedp2127: "programu Fundusze Europejskie dla Podlaskiego 2021-2027",
    default:
      ""
  },
  programYearsYm: {
    rpowp1420:
      "Regionalnym Programem Operacyjnym Województwa Podlaskiego na lata 2014-2020",
    fedp2127: "programem Fundusze Europejskie dla Podlaskiego 2021-2027",
    default:
      ""
  },
  programYm: {
    rpowp1420:
      "Regionalnym Programem Operacyjnym Województwa Podlaskiego",
    fedp2127: "programem Fundusze Europejskie dla Podlaskiego",
    default:
      ""
  },
  programPolicyAccept: {
    rpowp1420:
    "Uwaga: Proszę zapoznać się z Polityką Bezpieczeństwa Przetwarzania Danych Osobowych przetwarzanych w Urzędzie Marszałkowskim Województwa Podlaskiego w Białymstoku. Praca w aplikacji Portal KM RPOWP wymaga zapoznania się i akceptacji przedmiotowej polityki:",
    fedp2127: "Uwaga: Proszę zapoznać się z Polityką Bezpieczeństwa Przetwarzania Danych Osobowych przetwarzanych w Urzędzie Marszałkowskim Województwa Podlaskiego w Białymstoku. Praca w aplikacji Portal KM FEdP wymaga zapoznania się i akceptacji przedmiotowej polityki:",
    default:
      ""
  },
  programLicenseAccept: {
    rpowp1420:
    "Przed rozpoczęciem korzystatnia z Portalu KM RPOWP, należy zakceptować licencję.",
    fedp2127: "Przed rozpoczęciem korzystatnia z Portalu KM FEdP, należy zakceptować licencję.",
    default:
      ""
  },
  programDeclarationAccept: {
    rpowp1420:
    "Mając na uwadze „Wytyczne dotyczące unikania konfliktów interesów i zarządzania takimi konfliktami na podstawie rozporządzenia finansowego (2021/C 121/01)” Komisji Europejskiej oraz „Wytyczne w zakresie komitetów monitorujących na lata 2014-2020” Ministra Inwestycji i Rozwoju, do realizacji zadań w ramach KM RPOWP niezbędne jest zaakceptowanie Oświadczenia.",
    fedp2127: "Mając na uwadze „Wytyczne dotyczące unikania konfliktów interesów i zarządzania takimi konfliktami na podstawie rozporządzenia finansowego (2021/C 121/01)” Komisji Europejskiej oraz „Wytyczne w zakresie komitetów monitorujących na lata 2014-2020” Ministra Inwestycji i Rozwoju, do realizacji zadań w ramach KM FEdP niezbędne jest zaakceptowanie Oświadczenia.",
    default:
      ""
  },
  programPassActivationSuccess: {
    rpowp1420:
    "Hasło zostało aktywowane. W celu zalogowania do systemu proszę przejść do strony logowania Portalu KM RPOWP.",
    fedp2127: "Hasło zostało aktywowane. W celu zalogowania do systemu proszę przejść do strony logowania Portalu KM FEdP.",
    default:
      ""
  }
};

export const getSystemLabel = (key, systemInfo) => {
  // console.log(key)
  // console.log(systemInfo)

  if (systemInfo?.fundProgram) {
    return kmSystemLabels[key][systemInfo.fundProgram];
  }

  return kmSystemLabels[key]["default"];
};
